/*
 * views/clubView.js
 * Club View
 */
define('app/views/clubView',[
    'lib/event',
    'underscore',
    'app/views/commonViewHelper',
    'hbs!app/views/templates/navbar',
    'hbs!app/views/templates/breadcrumbs',
    'hbs!app/views/templates/content',
    'hbs!app/views/templates/clubAccountList',
    'hbs!app/views/templates/clubAccount',
    'hbs!app/views/templates/clubStatementTable',
    'hbs!app/views/templates/clubGuestDirectory',
    'bootstrap'
], function(Event, _, commonViewHelper, navbarTpl, breadcrumbsTpl, contentTpl, clubAccountList, clubAccount, clubStatementTable,clubGuestDirectory) {
    var clubView = {
        app: app,
        event: $.extend({}, Event),
        module: "club",
        render: function(template, data, breadcrumbs) {

        }
    };
    var setBreadCrumb = function(crumbText, crumbLink) {
//        app.data.breadCrumbs = app.data.breadCrumbs || {};
//        app.data.breadCrumbs.golf = app.data.breadCrumbs.golf || [];
//        var spliceCrumbsAt = -1,
//                existingCrumb = $.grep(app.data.breadCrumbs.golf, function(crumb, index) {
//            if (crumb.name == crumbText) {
//                spliceCrumbsAt = index;
//                return true;
//            }
//            return false;
//        }),
//                currentCrumb = {name: crumbText, url: crumbLink};
//
//        app.data.breadCrumbs.golf = existingCrumb.length ?
//                $.merge(app.data.breadCrumbs.golf.slice(0, spliceCrumbsAt), [currentCrumb]) :
//                $.merge(app.data.breadCrumbs.golf, [currentCrumb]);
//
//        for (var i = 0; i < app.data.breadCrumbs.golf.length; i++) {
//            app.data.breadCrumbs.golf[i].last = i == (app.data.breadCrumbs.golf.length - 1);
//        }
    };

    clubView.event.listen('indexAction', clubView, function(e, params) {
        var service = {name: app.localization.club.accounts, icon:"certificate"};
        $('#main').html(contentTpl({
            Localization: app.localization,
            services: app.data.serviceTypes,
            bannerMessage: '',
            siteName: app.localization.siteName,
            backLink: Customization.serverURL,
            service: service
        }));

        $('#content').addClass('clubAccountList').html(clubAccountList({
            Localization: app.localization,
            clubAccounts: params.Account
        }));

        $('#breadcrumbs').html(breadcrumbsTpl({
            'breadCrumbs': [
                {name: app.localization.club.myAccounts, last: 1}
            ]
        }));

        commonViewHelper.updateNavBar(service, app.language, !!app.data.SessionId && app.models.systemModel.dataModel.folioBalance.data[app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBalance, {})]);
        commonViewHelper.showMessages();
    });
    //part of guest Directory feature 
    
    clubView.event.listen('clubGuestDirectory', clubView, function(e, params) {
        var service = {name: app.localization.club.accounts, icon:"certificate"};
        $('#main').html(contentTpl({
            Localization: app.localization,
            services: app.data.serviceTypes,
            bannerMessage: '',
            siteName: app.localization.siteName,
            backLink: Customization.serverURL,
            service: service
        }));
        $('#breadcrumbs').html(breadcrumbsTpl({
            'breadCrumbs': [
                {name: app.localization.club.myAccounts, url: '#/membership'},
                {name: app.localization.club.membershipIndividual, url: '#/membership/account/'+params.accountId},
                {name:  app.localization.club.guestDirectory, last: 1},
            ]
        }))
        $('#content').addClass('clubGuestDirectory').html(clubGuestDirectory());
        commonViewHelper.updateNavBar(service,app.language,app.models.systemModel.dataModel.folioBalance.data[app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBalance,{})]);
        commonViewHelper.showMessages();
        commonViewHelper.handleClubDirectory(params.accountId,params.memberList);
    }),
    clubView.event.listen('accountAction', clubView, function(e, params) {
        
        var service = {name: app.localization.club.accounts, icon:"certificate"};
      
        $('#main').html(contentTpl({
            Localization: app.localization,
            services: app.data.serviceTypes,
            bannerMessage: '',
            siteName: app.localization.siteName,
            backLink: Customization.serverURL,
            service: service
        }));

        var memberships = [];

        //preparing account data
        for (var key in $.wrapArray(params.accountResponse.Memberships.Membership)) {
            if ($.wrapArray(params.accountResponse.Memberships.Membership)[key].Status !== "EXPIRED") {
                memberships.push($.wrapArray(params.accountResponse.Memberships.Membership)[key]);
            }
        }
        
        
        if ( params.clubStatementsResponse.Account[0] && params.clubStatementsResponse.Account[0].BillingPeriods && params.clubStatementsResponse.Account[0].BillingPeriods.BillingPeriod ) {
            var current = params.clubStatementsResponse.Account[0].BillingPeriods.BillingPeriod
            var first = params.clubBillingsResponse.BillingPeriod[0]
            if (!first || current.BillDate !== first.BillDate) {
                params.clubBillingsResponse.BillingPeriod.unshift(params.clubStatementsResponse.Account[0].BillingPeriods.BillingPeriod)
            }
        }
        $.each(params.clubBillingsResponse.BillingPeriod, function() {
            this.PeriodStartDateYearMonth = this.PeriodStartDate && Date.parse(this.PeriodStartDate.substr(0,10)).toString(app.localization.CultureInfo.formatPatterns.yearMonth);
            this.PeriodStartDateShortDate = this.PeriodStartDate && Date.parse(this.PeriodStartDate.substr(0,10)).toString(app.localization.CultureInfo.formatPatterns.shortDate);
            this.BillDateYearMonth = this.BillDate && Date.parse(this.BillDate.substr(0,10)).toString(app.localization.CultureInfo.formatPatterns.yearMonth);
            this.BillDateShortDate = this.BillDate && Date.parse(this.BillDate.substr(0,10)).toString(app.localization.CultureInfo.formatPatterns.shortDate);
        });
        // Preparing Billing Periods Desc Order By Month 
        params.clubBillingsResponse.BillingPeriod = _.sortBy(params.clubBillingsResponse.BillingPeriod, function(item){return Date.parse(item.BillDate)}).reverse();
        var hasStatementAccess = params.accountResponse.StatementAccess === 'Y';

        var viewData = {
            Localization: app.localization,
            accountData: params.accountResponse,
            accountMemberships: memberships,
            billings:$.wrapArray(params.clubBillingsResponse.BillingPeriod),
            accountStatement: params.clubStatementsResponse.Account[0],
            minimums: params.clubStatementsResponse.Account[0].Minimums.Minimum,
            currentBilling: params.clubBillingsResponse.BillingPeriod[0],
            hasStatementAccess: hasStatementAccess,
            clubpaymentEnabled : Customization.club.clubPaymentsEnabled || false,
        };

        // When the clubPostPayment call is made, the account balances change into posted payment regardless of whether the user has paid. If the user has not paid, it will stay there until web cleanup is run. Thus, there is no way fo knowing if the user has paid or not. The concept of "Online-Pending" was introduced to differentiate between processed payments vs. pending. 
        $.each([].concat(viewData.accountStatement.FolioPayments.FolioPayment),function(){
            if(this.Label == "Online-Pending")  {
                viewData.pendingPayment = (this.Amount).replace('-','')
            }
        })

        if (viewData.pendingPayment) {
            viewData.originalBalance = Number(params.clubStatementsResponse.Account[0].BillingPeriods.BillingPeriod.AccountBalance) + Number(viewData.pendingPayment)
        }
        $('#breadcrumbs').html(breadcrumbsTpl({
            'breadCrumbs': [
                {name: app.localization.club.myAccounts, url: '#/membership'},
                {name: viewData.accountData.AccountClass + ' ' + app.localization.club.membership, last: 1}
            ]
        }))
   
        $('#content').addClass('clubAccount').html(clubAccount(viewData));
        commonViewHelper.paginateClubStatements(params.accountResponse);
       
        $('.payment-div').click(function (e) {
            $(".payment-div").toggleClass('in');
            if ($(".payment-div").hasClass('in')) {
                $(".make--payment--div").css('display', 'block');
            } else {
                $(".make--payment--div").css("display", "none");
            }
        })
        //part of "pending payment. READ comments above"
        if(viewData.pendingPayment || params.nonClubBookingsInCart ){
            $('.suggested--payment').css("display", "none")
            $('.pull-right.payment--div').css("display", "none")
            $('.make--payment--div').append('<p>'+app.localization.club.err[params.nonClubBookingsInCart?"812":"811"]+'</p>')
        }

        $('.payment-div').on('keydown',function (e) {
            if(e.keyCode == 13) {
                $(this).click();
            }
        })

        $('.statement-table').click(function(e) {
            e.preventDefault();

            var billDate = $(this).data('bill-date');
            // check if billdate for CURRENT billing period
            var isCurrentPeriod = $(this).data('bill-current') == true ? 'CURRENT' : null;
            if ($(this).data('fetched')) {
                $('#collapse-' + billDate).collapse('toggle');
            } else {
                
                app.dispatcher.dispatch('membership', 'statement', [$(this).data('account-id'), billDate, hasStatementAccess, isCurrentPeriod]);
            }
        });

        $('#club-payment-amount-input').on('input', function() {
            if (parseFloat($('#club-payment-amount-input').val()) > 0) {
                $('#club--payment--btn').removeClass('disabled')
            } else {
                $(".suggested--payment > a").removeClass('active')
                $('#club--payment--btn').addClass('disabled')
            }
        })
        $('#club-payment-amount-input').bind('input', function () {
            $(".suggested--payment > a").removeClass('active');
        })

        dfd1 = []


        $('#club--payment--btn').on('click', function (e) {
            if ($('#club--payment--btn').hasClass('disabled')) {
                e.preventDefault()
            } else {
                if ($('#club-payment-amount-input').val()) {
                    var accountId = params.clubStatementsResponse.Account[0].AccountId,
                    amount =  $('#club-payment-amount-input').val()

                    $('#club--payment--btn').removeClass('disabled')
                    e.preventDefault()
                    
                    dfd1.push(app.commonViewHelper.resolveCustomization(app.customization.payment.requireExplicitTermsAccept, { clubData:params, type:'club' }));
                    $.when.apply(this, dfd1).always(function(termsResult){

                    // Terms And Conditions if it is callback funnction logic
                    if (termsResult && (app.data.termsAccepted == 'undefined' || !app.data.termsAccepted)) {
                        app.views.cartView.event.fire('showTermsModal', []);
                        $('.content-clubAccount #acceptTermsModal .continueBtn').unbind("click").bind("click", function () {
                            if ($(' .content-clubAccount #acceptTermsModal #acceptBox').attr('checked')) {
                                app.data.termsAccepted = true;
                                app.commonViewHelper.handlePayment(accountId,'CLUB',amount)
                                }
                        });
                        $('.content-clubAccount #acceptTermsModal').unbind("hide").bind("hide", function () { //do nothing 
                        })
                        return;
                        } else {
                            app.commonViewHelper.handlePayment(accountId,'CLUB',amount)
                        }
                    })
                } else {
                    e.preventDefault();
                    app.data.messages.push({
                        type: 'alert',
                        'class': 'alert-error',
                        actions: [],
                        title: app.localization.club.noValue,
                        message: ''
                    });
                }

            }
        })

        if (params.clubStatementsResponse.Account[0].Minimums != "") {
            if (Number(params.clubStatementsResponse.Account[0].Minimums.Minimum.MinimumTotal) < Number(params.clubStatementsResponse.Account[0].BillingPeriods.BillingPeriod.Charges)) {
                $('.minimum-total-text').text(app.localization.club.newCharges)
                $('.minimum-total-amount').text(app.localization.general.currencyPrefix + (+params.clubStatementsResponse.Account[0].BillingPeriods.BillingPeriod.Charges).toFixed(2) + app.localization.general.currencyPostfix)
                $('#minimum--payment--btn').data('payment-value', params.clubStatementsResponse.Account[0].BillingPeriods.BillingPeriod.Charges)
            }
            $('#minimum--payment--btn').on('click', function () {
                if ($('#minimum--payment--btn').hasClass('active')) {
                    return;
                } else {
                    var value = $('#minimum--payment--btn').data('payment-value');
                    $('#club-payment-amount-input').val(value);
                    $('#club--payment--btn').removeClass('disabled');
                }
            })
        } else {
            $('.minimum-total-text').text(app.localization.club.newCharges)
            $('.minimum-total-amount').text(app.localization.general.currencyPrefix + (+params.clubStatementsResponse.Account[0].BillingPeriods.BillingPeriod.Charges).toFixed(2) + app.localization.general.currencyPostfix)
            $('#minimum--payment--btn').data('payment-value', params.clubStatementsResponse.Account[0].BillingPeriods.BillingPeriod.Charges)
            $('#minimum--payment--btn').on('click', function () {
                if ($('#minimum--payment--btn').hasClass('active')) {
                    return;
                } else {
                    var value = $('#minimum--payment--btn').data('payment-value');
                    $('#club-payment-amount-input').val(value);
                    $('#club--payment--btn').removeClass('disabled');
                }
            })
        }

        if (Number(params.clubStatementsResponse.Account[0].BillingPeriods.BillingPeriod.PreviousBalance) <= 0) {
            $('.previous-payment-btn').remove()
        } else {
            $('#previous--payment--btn').on('click', function () {
                if ($('#previous--payment--btn').hasClass('active')) {
                    return
                } else {
                    var previousValue = $('#previous--payment--btn').data('payment-value');
                    $('#club-payment-amount-input').val(previousValue);
                    $('#club--payment--btn').removeClass('disabled');
                }
            })
        }

        if (Number(params.clubStatementsResponse.Account[0].BillingPeriods.BillingPeriod.AccountBalance) <= 0) {
            $('.account-payment-btn').remove()
        } else {
            $('#account--payment--btn').on('click', function (e) {
                e.preventDefault();
                if ($('#account--payment--btn').hasClass('active')) {
                    return
                } else {
                    var totalValue = $('#account--payment--btn').data('payment-value');
                    $('#club-payment-amount-input').val(totalValue);
                    $('#club--payment--btn').removeClass('disabled');
                }
            })
        }

        $('.suggested--payment > a').on('click', function() {
            $(this).addClass('active');
            $(this).siblings().removeClass('active');
        })

        commonViewHelper.updateNavBar(service, app.language, !!app.data.SessionId && app.models.systemModel.dataModel.folioBalance.data[app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBalance, {})]);
        commonViewHelper.showMessages();
    });

    clubView.event.listen('statementAction', clubView, function(e, params) {
        if (params.error) {
            $('#statement-table-' + params.billDate).html(app.localization.club.fetchTransactionsFail);
        } else {
            var postingItems;

            if (params.statementsResponse.Account[0].FolioItems.FolioItem) {
                params.statementsResponse.Account[0].FolioItems.FolioItem = $.wrapArray(params.statementsResponse.Account[0].FolioItems.FolioItem);
                //preparing charges data
                $.each(params.statementsResponse.Account[0].FolioItems.FolioItem, function() {
                    this.DateMonthDay = Date.parse(this.Date.substr(0,10)).toString(app.localization.CultureInfo.formatPatterns.monthDay);

                    if (this.ChargeDetails && this.ChargeDetails.PostingItem) {
                        this.ChargeDetails.PostingItem = $.wrapArray(this.ChargeDetails.PostingItem);

                        $.each(this.ChargeDetails.PostingItem, function() {
                            this.Item.DateMonthDay = this.Item.Date&&Date.parse(this.Item.Date.substr(0,10)).toString(app.localization.CultureInfo.formatPatterns.monthDay)||"";
                        });
                    }

                });
                // Order Charges by Date
                params.statementsResponse.Account[0].FolioItems.FolioItem = _.sortBy(params.statementsResponse.Account[0].FolioItems.FolioItem, "Date").reverse();
            }

            if (params.statementsResponse.Account[0].FolioPayments.FolioPayment) {
                params.statementsResponse.Account[0].FolioPayments.FolioPayment = $.wrapArray(params.statementsResponse.Account[0].FolioPayments.FolioPayment);
                $.each(params.statementsResponse.Account[0].FolioPayments.FolioPayment, function() {
                    this.DateMonthDay = Date.parse(this.Date.substr(0,10)).toString(app.localization.CultureInfo.formatPatterns.monthDay);
                    this.TransactionDate = this.TransactionDate ? this.TransactionDate.substr(0,10) : "N/A";
                });
                params.statementsResponse.Account[0].FolioPayments.FolioPayment = _.sortBy(params.statementsResponse.Account[0].FolioPayments.FolioPayment, "TransactionDate").reverse();
            }   

            var viewData = {
                Localization: app.localization,
                charges: params.statementsResponse.Account[0].FolioItems.FolioItem,
                minimums: params.statementsResponse.Account[0].Minimums.Minimum,
                payments: params.statementsResponse.Account[0].FolioPayments.FolioPayment,
                _current: params.statementsResponse._current,
                billings: $.wrapArray(params.statementsResponse.Account[0].BillingPeriods.BillingPeriod)
            };
        

            $('#statement-table-' + params.billDate).html(clubStatementTable(viewData));
        }

        $('.transaction-details').on('show hide', function(e) {
            if (!$(this).is(e.target)) {
                return;
            }
            if ($(this).parents('.statement-body').data('collapse')) {
                $(this).parents('.statement-body').collapse('reset');
            }
            $('#icon-' + $(this).data('folio-id')).toggleClass('icon-chevron-right icon-chevron-down', 200);
        });

        $('#toggle-' + params.billDate).data('fetched', true);
        $('#collapse-' + params.billDate).collapse();
    });

    return window.app.views.clubView = clubView;
});

